export default "__VITE_ASSET__DFda2CXU__"